var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5656 6.97917L6.99392 11.5508C6.30559 12.2392 6.30559 13.3558 6.99392 14.0442V14.0442C7.68225 14.7325 8.79892 14.7325 9.48725 14.0442L15.5139 8.0175C16.7764 6.755 16.7764 4.70834 15.5139 3.44584V3.44584C14.2514 2.18334 12.2048 2.18334 10.9423 3.44584L4.91559 9.4725C3.07892 11.3092 3.07892 14.2858 4.91559 16.1225V16.1225C6.75225 17.9592 9.72892 17.9592 11.5656 16.1225L15.2231 12.465",
    stroke: "#98A2B3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/attachment.0a00e8db6bb1f1898f274214e2b34cee.svg";
export { ForwardRef as ReactComponent };